import { api } from './api';

export interface HoroscopeTemplate {
  key: string;
  label: string;
  match: string;       // regex (string) que casa o título
  estrutura: string;   // estrutura-padrão do conteúdo
  ordem: number;
}

export interface HoroscopeTemplatesResponse {
  category_id: number;
  site: string | null; // site de publicação do horóscopo (a listagem filtra por ele)
  templates: HoroscopeTemplate[];
}

export const horoscopoApi = {
  getTemplates: (): Promise<HoroscopeTemplatesResponse> =>
    api.get<HoroscopeTemplatesResponse>('/horoscopo/templates'),
  saveTemplates: (templates: HoroscopeTemplate[]): Promise<HoroscopeTemplatesResponse> =>
    api.put<HoroscopeTemplatesResponse>('/horoscopo/templates', { templates }),
};
